/**
 * `SITE-CRS01`: what a course page or a catalogue card may say about a live
 * cohort's start, from the record's date alone (`docs/11`: dates come from
 * course fields, and an empty field leaves the line out).
 *
 * - Before the start: "upcoming", with whole days to go.
 * - From the start until seven days after it: "started". The same window as the
 *   backend's `LIVE_WINDOW_DAYS`, which marks such a course `launchState: "live"`
 *   and puts it under the catalogue's Live cohort filter (founder decision 2,
 *   2026-10-05).
 * - Later than that, or no date: nothing. A past date is never "next".
 */
export type CohortStatus =
  | { kind: "upcoming"; days: number }
  | { kind: "started" };

const MS_PER_DAY = 86_400_000;
export const COHORT_STARTED_WINDOW_DAYS = 7;

export function cohortStatus(
  iso: string | null | undefined,
  now: Date = new Date(),
): CohortStatus | null {
  const raw = iso?.trim();
  if (!raw) return null;
  const start = new Date(raw).getTime();
  if (Number.isNaN(start)) return null;
  const diff = start - now.getTime();
  if (diff > 0) return { kind: "upcoming", days: Math.ceil(diff / MS_PER_DAY) };
  if (-diff < COHORT_STARTED_WINDOW_DAYS * MS_PER_DAY) return { kind: "started" };
  return null;
}
